import { _ as _asyncToGenerator, r as regenerator } from '../../index-33ee6c9f.js';
import { GEO_ZONE_KEY } from '../../configs/constants/index.js';
import { getObjectFromLocalStorage, setObjectToLocalStorage } from '../browserStorage/index.js';

var fetchGeoZone = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var _yield$import, API_URL, get, _ref2, status, response, _ref3, country, city, country_code, geoZoneInfo;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('../../configs/constants/index.js');
        case 2:
          _yield$import = _context.sent;
          API_URL = _yield$import.API_URL;
          _context.next = 6;
          return import('../../Fetch/index.js');
        case 6:
          get = _context.sent["default"].get;
          _context.next = 9;
          return get("".concat(API_URL, "/location"));
        case 9:
          _ref2 = _context.sent;
          status = _ref2.status;
          response = _ref2.response;
          if (!(status === 'success')) {
            _context.next = 17;
            break;
          }
          _ref3 = (response === null || response === void 0 ? void 0 : response.resolved_location) || {}, country = _ref3.country, city = _ref3.city, country_code = _ref3.country_code;
          geoZoneInfo = {
            country: country,
            city: city,
            country_code: country_code
          };
          setObjectToLocalStorage(GEO_ZONE_KEY, geoZoneInfo);
          return _context.abrupt("return", geoZoneInfo);
        case 17:
          return _context.abrupt("return", null);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchGeoZone() {
    return _ref.apply(this, arguments);
  };
}();
var getGeoZone = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var storageGeoZone;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          storageGeoZone = getObjectFromLocalStorage(GEO_ZONE_KEY);
          if (!storageGeoZone) {
            _context2.next = 4;
            break;
          }
          fetchGeoZone()["catch"](console.error); // this call should be done async without await for revalidation of data in local storage
          return _context2.abrupt("return", storageGeoZone);
        case 4:
          return _context2.abrupt("return", fetchGeoZone());
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getGeoZone() {
    return _ref4.apply(this, arguments);
  };
}();

export { getGeoZone as default };
//# sourceMappingURL=index.js.map
